import { createContext } from 'utils/react-helpers';

export const SnackbarContext = createContext({
  name: 'SnackbarContext',
  strict: false,
});
